import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

class Memos extends Component {
    state = {
        memoValue: ''
    };

    textareaRef = React.createRef();

    handleChange = (event) => {
        const memoValue = this.state.memoValue;
        const text = this.textareaRef.current.value;
        this.setState({memoValue: text});
        console.log(`memoValue: ${this.state.memoValue}`);
    };

    handleMemoDel = () => {
        const memoValue = this.state.memoValue;
        this.textareaRef.current.value = '';
        this.setState({memoValue: ''});
        console.log(`memoValue: ${this.state.memoValue}`);
    };
    render() {
        console.log(`textareaRef: ${this.textareaRef}`);
        return (
            <form onSubmit={this.handleMemoDel}>
                <article className={this.props.examMemoClass === true ? "memo-show memo-container flex-column" : "memo-container flex-column"}>
                    <div className="memo-header d-flex">
                        <h4 className="w-100 h-100 m-0 text-center">1문항 메모</h4>
                        <button type="button" className="btn close-btn" onClick={this.props.onExamMemo}>
                            <span className="icon-wrap">
                                <svg className="icon close-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path className="fill this-target" d="M153.212,158l4.537-4.537a.857.857,0,0,0-1.212-1.212L152,156.788l-4.537-4.537a.857.857,0,0,0-1.212,1.212L150.788,158l-4.537,4.537a.857.857,0,0,0,1.212,1.212L152,159.212l4.537,4.537a.857.857,0,0,0,1.212-1.212Z" transform="translate(-140 -146)" fill="#999"/>
                                </svg>
                            </span>
                        </button>
                    </div>

                    <div className="memo-body d-flex flex-column p-0 m-0">
                        <Tabs>
                            <TabList>
                                <Tab>1번</Tab>
                                <Tab>2번</Tab>
                            </TabList>

                            <TabPanel>
                                <textarea ref={this.textareaRef} value={this.state.memoValue} onChange={this.handleChange} placeholder="1번 문항 메모 입력"></textarea>
                                <div className="memo-footer btn-wrap">
                                    <button type="button" className="btn del-btn" onClick={this.handleMemoDel}>내용 삭제</button>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <textarea placeholder="2번 문항 메모 입력"></textarea>
                                <div className="memo-footer btn-wrap">
                                    <button type="button" className="btn del-btn" onClick={this.handleMemoDel}>내용 삭제</button>
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </article>
            </form>
        );
    }
}

export default Memos;